import { useState } from 'react';
import type { UpdateAccountUserRoleRequest, UpdateAccountUserRoleResponse } from 'vopay';
import vopayApi from '@/services/api.config';

const { api } = vopayApi;

/**
 * Direct Pattern hook for updating an account-level user Role.
 * Hits POST /account/user-roles/update.
 */
export default function useUpdateUserRole() {
  const [submitting, setSubmitting] = useState(false);

  async function updateUserRole(
    params: UpdateAccountUserRoleRequest,
    bearer?: string,
  ): Promise<UpdateAccountUserRoleResponse> {
    try {
      setSubmitting(true);
      const res = await api.postUpdateAccountUserRole(params, undefined, bearer);
      if (!res.Success) {
        throw new Error(res.ErrorMessage);
      }
      return res;
    } catch (error) {
      console.error('Update account user role failed:', error);
      throw error;
    } finally {
      setSubmitting(false);
    }
  }

  return { submitting, updateUserRole };
}
